<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-title px-2 pt-2 w-100">
        <div [ngClass.xl]="'float-left'" [ngClass.md]="'float-left'" [ngClass.sm]="'mb-075'">
          <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" autocomplete="off" class="form-control" [(ngModel)]="searchKeyword" (ngModelChange)="filterTypes()" />
        </div>
        <div class="float-right">
          <div [ngClass.xl]="'w-fit d-inline-block mr-2'" [ngClass.md]="'w-fit d-inline-block mr-2'" [ngClass.sm]="'d-none'">
            <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
          </div>
          <a (click)="modalOpen(serviceAdd, null)" has_capability="create_invoice_service" class="btn btn-outline-primary text-primary">{{ "ADD" | translate }}</a>
        </div>
      </div>
      <div class="card-body p-0">
        <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="30" [footerHeight]="60" [limit]="tableLimit" [rows]="filteredServices" [sorts]="[{ prop: 'name', dir: 'asc' }]"
                       [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }" [scrollbarH]="true" [scrollbarV]="false" [rowHeight]="_utilService.isDesktop ? 50 : 170">
          <ngx-datatable-column [name]="'NAME' | translate" prop="name" [sortable]="true" *ngIf="_utilService.isDesktop" width="250">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.name }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'CODE' | translate" prop="other.code" [sortable]="false" width="70" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.other.code }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'STORAGE_UNIT_MEASURE' | translate" [sortable]="false" prop="other.storage_unit_measure" width="60" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.other.storage_unit_measure }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'CODE_PURCHASES' | translate" [sortable]="false" prop="other.code_purchases" width="60" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.other.code_purchases }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'PURCHASES_VAT' | translate" [sortable]="false" prop="other.purchases_vat" width="60" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.other.purchases_vat }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'SALES_ACCOUNT_CODE' | translate" [sortable]="false" prop="other.sales_account_code" width="60" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.other.sales_account_code }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'SALES_VAT' | translate" [sortable]="false" prop="other.sales_vat" width="60" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.other.sales_vat }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'USE_AS_DEFAULT' | translate" [sortable]="false" prop="other.default" width="60" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ (row.other.default ? 'YES' : 'NO') | translate }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false" width="10" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <button (click)="modalOpen(serviceEdit, row)" class="bg-transparent border-0 text-secondary pr-1" has_capability="edit_invoice_row_type">
                  <i [data-feather]="'edit-2'" size="19"></i>
                </button>
                <button (click)="deleteService(row)" class="bg-transparent border-0 text-danger remove-item" has_capability="delete_invoice_row_type">
                  <i [data-feather]="'trash-2'" size="19"></i>
                </button>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ng-template ngx-datatable-cell-template let-row="row" *ngIf="!_utilService.isDesktop">
            <div class="row list-item-mobile">
              <div class="col-12">
                <span class="font-weight-bold">{{ "NAME" | translate }}: </span>
                <span>{{ row.name }}</span>
              </div>
              <div class="col-12">
                <span class="font-weight-bold">{{ "CODE" | translate }}: </span>
                <span>{{ row.other.code }}</span>
              </div>
              <div class="col-12 mt-075 text-right" [ngClass.md]="'pr-2'">
                <button (click)="modalOpen(serviceEdit, row)" class="bg-transparent border-0 text-secondary pr-1" has_capability="edit_invoice_row_type">
                  <i [data-feather]="'edit-2'" size="19"></i>
                </button>
                <button (click)="deleteService(row)" class="bg-transparent border-0 text-danger remove-item" has_capability="delete_invoice_row_type">
                  <i [data-feather]="'trash-2'" size="19"></i>
                </button>
              </div>
            </div>
          </ng-template>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>


<!-- Modal Add -->
<ng-template #serviceAdd let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "ALERT.ADD_NEW_SERVICE" | translate }}</h3>
    <div class="row">
      <div class="form-group col-lg-8 col-12">
        <label for="name1">{{ "NAME" | translate }}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="serviceForm.name" name="name" type="text" maxlength="25" id="name1" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!serviceForm.name || serviceForm.name.length < 1)">{{ "ERRORS.INSERT_NAME" | translate }}</div>
      </div>
      <div class="form-group col-lg-4 col-12">
        <label for="code1">{{ "CODE" | translate }}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="serviceForm.other.code" name="code" type="text" maxlength="50" id="code1" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!serviceForm.other.code || serviceForm.other.code < 1)">{{ "ERRORS.INSERT_CODE" | translate }}</div>
      </div>
      <div class="form-group col-lg-6 col-12">
        <label for="storage_unit_measure">{{ "STORAGE_UNIT_MEASURE" | translate }}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="serviceForm.other.storage_unit_measure" type="text" maxlength="2" id="storage_unit_measure" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!serviceForm.other.storage_unit_measure || serviceForm.other.storage_unit_measure.length < 1)">{{ "ERRORS.FIELD_REQUIRED" | translate }}</div>
      </div>
      <div class="form-group col-lg-6 col-12">
        <label for="code_purchases">{{ "CODE_PURCHASES" | translate }}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="serviceForm.other.code_purchases" type="text" maxlength="10" id="code_purchases" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!serviceForm.other.code_purchases || serviceForm.other.code_purchases.length < 1)">{{ "ERRORS.FIELD_REQUIRED" | translate }}</div>
      </div>
      <div class="form-group col-lg-6 col-12">
        <label for="purchases_vat">{{ "PURCHASES_VAT" | translate }}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="serviceForm.other.purchases_vat" type="text" maxlength="4" id="purchases_vat" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!serviceForm.other.purchases_vat || serviceForm.other.purchases_vat.length < 1)">{{ "ERRORS.FIELD_REQUIRED" | translate }}</div>
      </div>
      <div class="form-group col-lg-6 col-12">
        <label for="sales_account_code">{{ "SALES_ACCOUNT_CODE" | translate }}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="serviceForm.other.sales_account_code" type="text" maxlength="10" id="sales_account_code" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!serviceForm.other.sales_account_code || serviceForm.other.sales_account_code.length < 1)">{{ "ERRORS.FIELD_REQUIRED" | translate }}</div>
      </div>
      <div class="form-group col-lg-6 col-12">
        <label for="sales_vat">{{ "SALES_VAT" | translate }}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="serviceForm.other.sales_vat" type="text" maxlength="4" id="sales_vat" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!serviceForm.other.sales_vat || serviceForm.other.sales_vat.length < 1)">{{ "ERRORS.FIELD_REQUIRED" | translate }}</div>
      </div>
      <div class="form-group col-lg-6 col-12">
        <label for="default">{{ "USE_AS_DEFAULT" | translate }}</label>
        <ng-select [(ngModel)]="serviceForm.other.default" id="default" [searchable]="true" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true">
          <ng-option [value]="true">{{ "YES" | translate }}</ng-option>
          <ng-option [value]="false">{{ "NO" | translate }}</ng-option>
        </ng-select>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>{{ "CANCEL" | translate }}</button>
    <button type="submit" class="btn btn-primary w-150" rippleEffect (click)="addService()">{{ "SAVE" | translate }}</button>
  </div>
</ng-template>
<!-- / Modal Add -->

<!-- Modal edit -->
<ng-template #serviceEdit let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "ALERT.EDIT_SERVICE" | translate }}</h3>
    <div class="row">
      <div class="form-group col-lg-8 col-12">
        <label for="name">{{ "NAME" | translate }}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="serviceForm.name" name="name" type="text" maxlength="25" id="name" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!serviceForm.name || serviceForm.name.length < 1)">{{ "ERRORS.INSERT_NAME" | translate }}</div>
      </div>
      <div class="form-group col-lg-4 col-12">
        <label for="code">{{ "CODE" | translate }}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="serviceForm.other.code" name="code" type="text" maxlength="25" id="code" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!serviceForm.other.code || serviceForm.other.code < 1)">{{ "ERRORS.INSERT_CODE" | translate }}</div>
      </div>
      <div class="form-group col-lg-6 col-12">
        <label for="storage_unit_measure2">{{ "STORAGE_UNIT_MEASURE" | translate }}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="serviceForm.other.storage_unit_measure" type="text" maxlength="2" id="storage_unit_measure2" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!serviceForm.other.storage_unit_measure || serviceForm.other.storage_unit_measure.length < 1)">{{ "ERRORS.FIELD_REQUIRED" | translate }}</div>
      </div>
      <div class="form-group col-lg-6 col-12">
        <label for="code_purchases2">{{ "CODE_PURCHASES" | translate }}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="serviceForm.other.code_purchases" type="text" maxlength="10" id="code_purchases2" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!serviceForm.other.code_purchases || serviceForm.other.code_purchases.length < 1)">{{ "ERRORS.FIELD_REQUIRED" | translate }}</div>
      </div>
      <div class="form-group col-lg-6 col-12">
        <label for="purchases_vat2">{{ "PURCHASES_VAT" | translate }}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="serviceForm.other.purchases_vat" type="text" maxlength="4" id="purchases_vat2" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!serviceForm.other.purchases_vat || serviceForm.other.purchases_vat.length < 1)">{{ "ERRORS.FIELD_REQUIRED" | translate }}</div>
      </div>
      <div class="form-group col-lg-6 col-12">
        <label for="sales_account_code2">{{ "SALES_ACCOUNT_CODE" | translate }}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="serviceForm.other.sales_account_code" type="text" maxlength="10" id="sales_account_code2" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!serviceForm.other.sales_account_code || serviceForm.other.sales_account_code.length < 1)">{{ "ERRORS.FIELD_REQUIRED" | translate }}</div>
      </div>
      <div class="form-group col-lg-6 col-12">
        <label for="sales_vat2">{{ "SALES_VAT" | translate }}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="serviceForm.other.sales_vat" type="text" maxlength="4" id="sales_vat2" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!serviceForm.other.sales_vat || serviceForm.other.sales_vat.length < 1)">{{ "ERRORS.FIELD_REQUIRED" | translate }}</div>
      </div>
      <div class="form-group col-lg-6 col-12">
        <label for="default2">{{ "USE_AS_DEFAULT" | translate }}</label>
        <ng-select [(ngModel)]="serviceForm.other.default" id="default2" [searchable]="true" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true">
          <ng-option [value]="true">{{ "YES" | translate }}</ng-option>
          <ng-option [value]="false">{{ "NO" | translate }}</ng-option>
        </ng-select>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>{{ "CANCEL" | translate }}</button>
    <button type="submit" class="btn btn-primary w-150" rippleEffect (click)="editService()">{{ "EDIT" | translate }}</button>
  </div>
</ng-template>
<!-- / Modal edit -->